import InputLogin from './InputLogin';

export default InputLogin;



// WEBPACK FOOTER //
// ./src/scenes/Login/components/InputLogin/index.ts